module.exports = __webpack_public_path__ + "img/20191007155714098.2b8994ee.jpg";